import { yupResolver } from "@hookform/resolvers/yup";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import React from "react";
import { Controller, FormProvider, useForm } from "react-hook-form";
import * as Yup from "yup";
import FormInput from "../Form/FormInput";

const validationSchema = Yup.object({
  name: Yup.string().required("Firmenname eingeben"),
  hasSelfTests: Yup.bool(),
  defaultSelfTests: Yup.number().integer().max(2),
});

export interface CompanyFormValues {
  name: string;
  hasSelfTests: boolean;
  defaultSelfTests?: number;
}
export type CompanyFormFunction = (values: CompanyFormValues) => Promise<any>;

interface Props {
  onSubmit: CompanyFormFunction;
  loading?: boolean;
  initi?: CompanyFormValues;
}

const initialValues: CompanyFormValues = {
  name: "",
  hasSelfTests: false,
  defaultSelfTests: 2,
};
const useStyles = makeStyles((theme) => ({
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 250,
  },
  settingsWrapper: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));
const CompanyForm: React.FC<Props> = ({ onSubmit, loading, initi }) => {
  const classes = useStyles();
  const methods = useForm<CompanyFormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: { ...initialValues, ...initi },
    mode: "all",
  });
  const { handleSubmit, control } = methods;
  return (
    <FormProvider {...methods}>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <FormInput
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="name"
          label="Firmen name"
        />
        <div className={classes.settingsWrapper}>
          <Controller
            name="hasSelfTests"
            control={control}
            render={({ field: { onChange, value } }) => (
              <FormControlLabel
                control={
                  <Checkbox
                    checked={value}
                    onChange={onChange}
                    name="hasSelfTests"
                    color="primary"
                  />
                }
                label="Selbtestsausgabe aktiv"
              />
            )}
          />
          <Controller
            name="defaultSelfTests"
            control={control}
            render={({ field: { onChange, value } }) => (
              <FormControl className={classes.formControl}>
                <InputLabel id="select-defaultSelfTests-label">
                  Standartausgabe Selbttests
                </InputLabel>
                <Select
                  labelId="select-defaultSelfTests-label"
                  id="select-defaultSelfTests-select"
                  value={value}
                  onChange={onChange}
                >
                  <MenuItem value={0}>0</MenuItem>
                  <MenuItem value={1}>1</MenuItem>
                  <MenuItem value={2}>2</MenuItem>
                </Select>
              </FormControl>
            )}
          />
        </div>
        <Button
          type="submit"
          fullWidth
          disabled={loading}
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick={handleSubmit(onSubmit)}
        >
          Speichern
        </Button>
      </form>
    </FormProvider>
  );
};

export default CompanyForm;
